import { evolucional_redirect_url } from "../constants/general";
import { redirect } from "./misc";

export function logout() {
    this.isLoading();
    this.$store.dispatch("logout")
        .then(() => {
            redirect(evolucional_redirect_url);
        })
}
